'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.createTicket = createTicket;
exports.createLeadTicket = createLeadTicket;
exports.uploadFile = uploadFile;
exports.cacheTicket = cacheTicket;
exports.sendCacheTicket = sendCacheTicket;
exports.resetZendesk = resetZendesk;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESET = 'ms/zendesk/reset';
var CREATE = 'ms/zendesk/create_ticket';
var CACHE = 'ms/zendesk/cache_ticket';
var CREATE_SUCCESS = 'ms/zendesk/create_success';
var CREATE_FAIL = 'ms/zendesk/create_fail';

var UPLOAD_CREATE = 'ms/zendesk/create_upload';
var UPLOAD_SUCCESS = 'ms/zendesk/upload_success';
var UPLOAD_FAIL = 'ms/zendesk/upload_fail';

//Reducer
var initialState = {
  posting: false,
  posted: false,
  uploaded: false,
  uploading: false,
  postError: null,
  cacheMessage: {},
  token: ""
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CREATE:
      return (0, _extends3.default)({}, state, {
        posting: true,
        posted: false,
        postError: null
      });
    case CACHE:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: true,
        postError: null,
        cacheMessage: action.cacheMessage
      });

    case CREATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: true,
        postError: null,
        cacheMessage: {}
      });

    case UPLOAD_CREATE:
      return (0, _extends3.default)({}, state, {
        posting: true,
        uploading: true,
        posted: false,
        uploaded: false,
        postError: null,
        token: ''
      });

    case UPLOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: true,
        uploading: false,
        uploaded: true,
        postError: null,
        token: action.result.upload.token
      });

    case UPLOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: false,
        uploading: false,
        uploaded: false,
        postError: action.error,
        token: ''
      });

    case CREATE_FAIL:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: false,
        postError: action.error,
        token: ''
      });

    case RESET:
      return (0, _extends3.default)({}, state, {
        posting: false,
        posted: false,
        postError: null,
        cacheMessage: {},
        token: ""
      });

    default:
      return state;
  }
}

// Action creators
function createTicket(_ref) {
  var email = _ref.email,
      comment = _ref.comment,
      tag = _ref.tag,
      name = _ref.name,
      subject = _ref.subject,
      uploads = _ref.uploads,
      custom_fields = _ref.custom_fields;


  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: function promise(client) {
      return client.post('/v1/tickets', { data: { email: email, comment: comment, tag: tag, name: name, subject: subject, uploads: uploads, custom_fields: custom_fields } });
    }
  };
}
function createLeadTicket(obj) {

  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: function promise(client) {
      return client.post('/v1/tickets/leads', { data: obj });
    }
  };
}

function uploadFile(file, filename) {

  var additionalHeaders = { 'Content-Type': 'application/binary' };
  var externalCall = true;
  return {
    types: [UPLOAD_CREATE, UPLOAD_SUCCESS, UPLOAD_FAIL],
    promise: function promise(client) {
      return client.post('zen://v2/uploads.json?filename=file.png', { data: file, additionalHeaders: additionalHeaders, externalCall: externalCall });
    }
  };
}

function cacheTicket(data) {
  return {
    type: CACHE,
    cacheMessage: data
  };
}
function sendCacheTicket() {
  return function (dispatch, getState) {
    var obj = getState().cacheMessage;
    obj.token = getState().token;
    return {
      types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
      promise: function promise(client) {
        return client.post('/v1/tickets', { data: getState().cacheMessage });
      }
    };
  };
}
function resetZendesk() {
  return {
    type: RESET
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/zendesk.js
// module id = 95
// module chunks = 0